export const useFooterNav = () => {
  const navLoading = ref(false);

  const runWithLoading = async (fn: () => unknown | Promise<unknown>) => {
    if (navLoading.value) return;
    navLoading.value = true;
    try {
      await fn();
    } finally {
      navLoading.value = false;
    }
  };

  return { navLoading, runWithLoading };
};
